import React from "react"
import type { ReducedBlogV2TagType } from "types/blog-v2-types"

import { blogSlug } from "components/Blog/utils/Blog.utils"
import { container, tagsContainer, tagContainer } from "./PostTags.css"

type Props = {
  tags: ReducedBlogV2TagType[]
  locale: "en-GB" | "en-US"
}

export const PostTags: React.FC<Props> = ({ tags, locale }) => (
  <div className={container}>
    <p>Tags</p>
    <div className={tagsContainer}>
      {tags.map((tag) => {
        const { slug, title, hideOnSite } = tag
        if (hideOnSite === true) return
        return (
          <div className={tagContainer} key={`tag-${slug}`}>
            <a
              href={`${locale === "en-US" ? "/us" : ""}${blogSlug}/tag/${slug}`}
              title={title}
            >
              <p>{title}</p>
            </a>
          </div>
        )
      })}
    </div>
  </div>
)
